import React, {Component}  from 'react';
import _                   from 'lodash';
import AppActions          from './../../actions/AppActions';
import { CustomInput }     from 'reactstrap';

class BoundCheckbox extends Component {
    render() {
        const { path, checked, handleOnChange, inlineLabel, ...componentProps} = this.props;

        const handleChange = (event) => {
            const checked = event.target.checked;

            if (_.isFunction(handleOnChange)) {
                handleOnChange(checked);
            } else {
                AppActions.updateState(path, checked);
            }
        };

        return (
            <CustomInput
                type="checkbox"
                onChange={handleChange}
                {...componentProps}
                checked={checked}
                label={inlineLabel && inlineLabel}
                inline
            />
        )
    }
}

export default BoundCheckbox;